<template>
	<div class="c-board-empty-state">
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M5 6H19M7 3H17M5 21H19C20.1046 21 21 20.1046 21 19V11C21 9.89543 20.1046 9 19 9H5C3.89543 9 3 9.89543 3 11V19C3 20.1046 3.89543 21 5 21Z"
				stroke="currentColor"
				stroke-linecap="round"
			/>
		</svg>

		<h4>This board is empty</h4>
		<p>Save ads in this board to fill it up.</p>
	</div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.c-board-empty-state {
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
	padding: var(--spacer);

	h4 {
		margin-bottom: 0.5rem;
	}

	svg {
		width: 64px;
		height: 64px;
		margin-bottom: 1rem;
	}
}
</style>
